import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../components/DashboardLayout';

const Dashboard = () => {
  const { user, isAdmin } = useAuth();

  return (
    <DashboardLayout pageTitle="Dashboard">
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-800 dark:text-white">Welcome {isAdmin ? "Admin" : "Staff User"},</h1>
          <p className="mt-2 text-lg text-gray-600 dark:text-gray-400">{user?.email}</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;